// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__HAdP5","active":"NavigationItem_active__UHJiy","NavigationItemIcon":"NavigationItem_NavigationItemIcon__wzVuZ"};